export const MIXPANEL_RECORD_SESSION_PERCENT = 25;

export const EXPERIMENTS = {
    CHEETAHS_BOOK_PUBLISHING: 4998,
};
